import { SpineConfigSchema, SpineSymbolConfig, SpineSequenceElement, SpineSequenceSchema } from "slotworks/config/spine-config-schema";
import {Spine, SpineBase} from 'pixi-spine';
import ExtendedSpine from "slotworks/graphics/spine/spine";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import SpineSequence from "slotworks/graphics/spine/spine-sequence";

class SpineManager {
    private spineDatas: Map <string, SpineData>;
    private spineSymbols: Map <string, SpineSymbolConfig>;

    private spines: Map<string, ExtendedSpine[]>;

    public config: SpineConfigSchema;
    
    constructor() {
        this.spineDatas = new Map();
        this.spines = new Map();
    }

    public setSpineData(name: string, spineData: SpineData) {
        this.spineDatas.set(name, spineData);
    }

    public createSpineSymbol(name: string): ExtendedSpine {
        const config = this.spineSymbols.get(name);
        let data = this.spineDatas.get(config.spine);
        let animation = new ExtendedSpine(data as any, config);
        if(config.skin) {
            animation.setSkin(config.skin);
        }
        if(canvasManager.orientation == Orientation.PORTRAIT) {
            const scale = deviceInfo.widePortrait ? config.portraitV2Scale : config.portraitScale;
            animation.scale.x = animation.scale.y = scale;
        } else {
            animation.scale.x = animation.scale.y = config.landscapeScale;
        }
        return animation;
    }

    // spine-name-animation-skin-loop
    public createSpine(name: string, animation: string = null, skin: string = null, loop: boolean = false) {
        let data = this.spineDatas.get(name);
        let spine = new ExtendedSpine(data as any);
        if(skin) {
            spine.setSkin(skin);
        }
        if(animation)  {
            spine.play(0, animation, loop);
        }
        return spine;
    }
    
    public releaseSpine(name: string, spine: ExtendedSpine) {
        if(!this.spines.has(name)) {
            this.spines.set(name, []);
        }
        const spinesArray = this.spines.get(name);
        spinesArray.push(spine);
    }

    public setConfig(config: SpineConfigSchema) {
        this.config = config;
        this.spineSymbols = new Map();
        for(let symbol of config.symbols) {
            this.spineSymbols.set(symbol.symbol, symbol);
        }
    }

    public createSequence(sequence: string, skin: string = null) {
        // @ts-ignore
        const schema = this.config.sequences[sequence] as SpineSequenceSchema;
        const skins = schema.skins?.filter((el) => el.id == skin);
        
        const spine = this.createSpine(schema.spine, null, skins?.length > 0 ? skins[0].name : skin);
        
        const spineSequence = new SpineSequence(spine, schema);
        return spineSequence;
    }
}
export default new SpineManager(); 

interface SpineData {
    spineData: any;// PIXI.spine.core.SkeletonData;
    options: {
        loop: boolean;
        defaultAnimation: string;
        defaultSkin: string;
        offset: {
            x: number,
            y: number
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/spine/spine-manager.ts